import { integerValidationMessage } from "@/utils/validators";
import { helpers, integer, required, minValue, maxValue } from "@vuelidate/validators";

export default () => ({
    diagnosisDate: {
        required: helpers.withMessage("The diagnosis date field is required.", required),
    },
    occurrences: {
        integer: helpers.withMessage(integerValidationMessage, integer),
        minValue: helpers.withMessage("Occurrences must be at least 1.", minValue(1)),
        maxValue: helpers.withMessage("Occurrences must be at most 999.", maxValue(999)),
    },
});
